import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

export default {
  postApi: (bvModal, params, callbackSuccess) => {
    return AppModel.post(
      'order/csv',
      bvModal,
      params,
      callbackSuccess,
      () => {}
    )
  },
  getStore: (key) => {
    return AppModel.getStore('mawashi_csv', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/OrderCsvModel.js